import { useFeatureToggle } from "./useFeatureToggle";

// The Connect pages are the People pages with the Here & Now revamp. Use "/people" when the flag is removed.
export const useConnectBasePath = () => {
  const { HereAndNowRevamp } = useFeatureToggle();

  return HereAndNowRevamp ? "/people" : "/connect";
};
